import { connect } from 'react-redux'
import { selectRoomById } from 'ducks/chat/selectors/rooms'
import MoreButtonView from './MoreButtonDropdown'

const select = (state, props) => {
  const room = selectRoomById(state, props.conversationId)

  return {
    room,
  }
}

export default connect(select)(MoreButtonView)
